import HeaderContent from "component/layout/HeaderContent";
import { observer, useLocalObservable } from "mobx-react";
import TopHeader from "pages/HomePage/component/TopHeader";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRootStore } from "store/StoreContextProvider";
import TaskListTabs from "./component/TaskListTabs";
import EmployeeTopIntro from "./component/EmployeeTopIntro";
import EmployeeDetailPageStore from "./store/EmployeeDetailPageStore";
import TaskList from "./component/TaskList";
import TaskGradeDrawer from "./component/TaskGradeDrawer";
import React from "react";
import { CircularProgress, Grid } from "@mui/material";
import useSnackbarMessage from "shared/snackbar";

function EmployeeDetailPage() {
  const { headerStore } = useRootStore();
  const snackbar = useSnackbarMessage();
  const location = useLocation();
  const { loginStore } = useRootStore();
  const navigate = useNavigate();
  const pageStore = useLocalObservable(() => new EmployeeDetailPageStore());
  const [isDrawerVisible, setIsDrawerVisible] = React.useState<boolean>(false);

  useEffect(() => {
    if (location.state?.employee) {
      const employee = location.state.employee;
      pageStore.setEmployee(employee);
      headerStore.setPageTitle(`${employee.names?.fullname}`);
    }
    if (location.state.isAssessDone) {
      pageStore.setTabsValue("DONE");
    }
    //console.log(pageStore.employee);
    headerStore.setIsDoneAssess(false);

    fetchTaskList();
  }, []);

  const fetchTaskList = async () => {
    try {
      const employee = location.state.employee;
      const res: any = await pageStore.fetchTaskList(loginStore.currentUser);
      await loginStore.fetchConfigSettings();
      if (res?.expired) {
        loginStore.onLogout();
        navigate("/login");
        return;
      }
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };

  const handleClickTuneIcon = () => {
    setIsDrawerVisible(true);
  };

  return (
    <HeaderContent>
      <TopHeader
        isBackIcon
        isTuneIcon={pageStore.tabsValue === "DONE"}
        onClickTuneIcon={handleClickTuneIcon}
      />
      <EmployeeTopIntro pageStore={pageStore} />
      <TaskListTabs pageStore={pageStore} />
      {pageStore.isLoading ? (
        <Grid
          container
          justifyContent={"center"}
          style={{ marginTop: "150px" }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <TaskList pageStore={pageStore} />
      )}
      <TaskGradeDrawer
        isDrawerVisible={isDrawerVisible}
        setIsDrawerVisible={setIsDrawerVisible}
        pageStore={pageStore}
      />
    </HeaderContent>
  );
}

export default observer(EmployeeDetailPage);
